export default __webpack_public_path__ + "static/media/logo.9ee3b342.png";